import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosInstanceRow } from "../Config";

export const getBilling = createAsyncThunk("get-billings", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/billings/filter`, { params: payload });
    return apiResponse.data;
});

export const getAllBillListing = createAsyncThunk("get-all-billings", async (payload) => {
    const { month, year, page, provider, type } = payload;

    let endpoint = '/billings/filter?';

    if (month && year) {
        endpoint += `month=${month}&year=${year}`; // /billings/month=January/year=2025
    } else if (month) {
        endpoint += `month=${month}`; // /billings/month=January
    }

    const params = {};
    if (page) params.page = page;
    if (provider) params.provider = provider;
    if (type) params.type = type;
    const apiResponse = await axiosInstanceRow.get(endpoint, { params });
    return apiResponse.data;
});


// post update billing
export const updateAmount = createAsyncThunk("update-amount", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/billing-data/update-amounts`, payload);
    return apiResponse.data;
});


// update confirmation {confirmation id, notes}
export const submitConfirmation = createAsyncThunk("submit-confirmation", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/billing-data/update-confirmation`, payload);
    return apiResponse.data;
});


// uplaod cheque 
export const uploadCheque = createAsyncThunk("upload-cheque", async (payload) => {
    const apiResponse = await axiosInstance.post(`/billings/upload-cheque`, payload);
    return apiResponse.data;
});

// get billing
export const getBillingDetail = createAsyncThunk("billing-detail", async (id) => {
    const apiResponse = await axiosInstanceRow.get(`/billings/${id}`);
    return apiResponse.data;
});


// get cheque details
export const getChequeDetail = createAsyncThunk("cheque-detail", async (id) => {
    const apiResponse = await axiosInstanceRow.get(`/cheque/analyze/${id}`);
    return apiResponse.data;
});

// get new member detail in billing
export const getNewMemberBillings = createAsyncThunk("get-new-member", async (payload) => {
    const apiResponse = await axiosInstanceRow.get(`/new-member`, payload);
    return apiResponse.data
})

// billing detail of new member
export const newMemberDetail = createAsyncThunk("new-member-detail", async (id) => {
    const apiResponse = await axiosInstanceRow.get(`/billing-detail/${id}`);
    return apiResponse.data
})

// post update billing
export const updateHistory = createAsyncThunk("update-history", async (payload) => {
    const apiResponse = await axiosInstanceRow.post(`/billing-data/update-amounts-history`, payload);
    return apiResponse.data;
});